import React from 'react';
import { Skeleton, Table } from 'antd';

const SkeletonTable = ({ columns, rowCount = 5, active = true }) => {
  return (
    <Table
      rowKey="key"
      size="small"
      pagination={false}
      dataSource={[...Array(rowCount)].map((_, index) => ({
        key: `key${index}`,
      }))}
      columns={columns.map((column) => {
        return {
          ...column,
          render: function renderPlaceholder() {
            return (
              <Skeleton
                key={column.dataIndex || column.key}
                title={true}
                paragraph={false}
                active={active}
              />
            );
          },
        };
      })}
    />
  );
};

export default SkeletonTable;
